/* NelySports kit builder */
(function () {
  'use strict';
  var A = window.KB_ASSETS || (window.KB_ASSETS = {}), CFG = window.KB_CONFIG;
  var VIEWS = CFG.views, GARMENTS = CFG.garments;
  var SIZES = CFG.sizes || ['YS', 'YM', 'YL', 'S', 'M', 'L', 'XL', '2XL', '3XL'];

  var cv = document.getElementById('cv'), cx = cv.getContext('2d');
  var G = GARMENTS[0], V = G.views[0], PAT = 'Solid', DENSITY = 7;
  var COL = {}, PATCOL = [242, 240, 234], QTY = {};
  var brandImg = null, cache = {}, imgs = {}, parts = {}, partCbs = {};
  var KITFONT = 'Helvetica, Arial, sans-serif', fontReady = false;

  function loadKitFont() {
    if (!A.font) return;

    // 1. a real @font-face rule, so engines without the FontFace API still get it
    var st = document.createElement('style');
    st.textContent = '@font-face{font-family:"NelyKit";font-style:normal;font-weight:400;' +
      'src:url(' + A.font + ') format("truetype");font-display:swap}';
    document.head.appendChild(st);

    // 2. force the browser to actually fetch it
    var probe = document.createElement('span');
    probe.textContent = 'NELY0123';
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:absolute;left:-9999px;top:-9999px;' +
      'font:400 96px "NelyKit", monospace;white-space:nowrap';
    document.body.appendChild(probe);

    // 3. the font is in once its metrics stop matching the fallback
    var probeCv = document.createElement('canvas').getContext('2d');
    probeCv.font = '400 96px monospace';
    var baseline = probeCv.measureText('NELY0123').width;
    var tries = 0;
    function check() {
      probeCv.font = '400 96px "NelyKit", monospace';
      if (probeCv.measureText('NELY0123').width !== baseline) {
        fontReady = true;
        if (probe.parentNode) probe.parentNode.removeChild(probe);
        render();
        return;
      }
      if (++tries < 40) setTimeout(check, 100);
      else if (probe.parentNode) probe.parentNode.removeChild(probe);
    }
    if (window.FontFace) {
      try {
        var ff = new FontFace('NelyKit', 'url(' + A.font + ')');
        ff.load().then(function (f) {
          document.fonts.add(f); fontReady = true;
          if (probe.parentNode) probe.parentNode.removeChild(probe);
          render();
        }, function () { setTimeout(check, 60); });
      } catch (e) { setTimeout(check, 60); }
    } else setTimeout(check, 60);
  }
  function textFont(px, weight) {
    var fam = fontReady ? '"NelyKit", Helvetica, Arial, sans-serif'
                        : 'Helvetica, Arial, sans-serif';
    return (weight || '600') + ' ' + Math.round(px) + 'px ' + fam;
  }

  var RASTER = /\.(png|jpe?g|svg)$/i;
  var SLOTS = [
    { id: 'crest', label: 'Club crest',    side: 'front', img: null, file: null, x: 0.50, y: 0.30, size: 16 },
    { id: 'spf',   label: 'Front sponsor', side: 'front', img: null, file: null, x: 0.50, y: 0.52, size: 30 },
    { id: 'spb',   label: 'Back sponsor',  side: 'back',  img: null, file: null, x: 0.50, y: 0.40, size: 32 }
  ];
  var ACTIVE = SLOTS[0], drag = false, LINKSLV = true;

  var PATTERNS = [
    'Solid',
    'Hoops', 'Thin hoops', 'Wide hoops', 'Half hoops', 'Fade hoops', 'Chest band', 'Thirds',
    'Stripes', 'Pinstripe', 'Racing stripes', 'Grid', 'Checkerboard', 'Diamonds', 'Argyle',
    'Dots', 'Honeycomb', 'Waves', 'Zigzag', 'Camo', 'Fade', 'Diagonal', 'Double diagonal',
    'Halves', 'Halves across', 'Quarters', 'Sash', 'Reverse sash', 'Double sash', 'Cross sash',
    'Chevron', 'Double chevron', 'Inverted chevron', 'V panel', 'Bib', 'Side panels',
    'Yoke', 'Shoulder flash', 'Corner block'
  ];
  var BODY_ONLY = ['Halves', 'Halves across', 'Quarters', 'Sash', 'Reverse sash',
                   'Double sash', 'Cross sash', 'Chevron', 'Double chevron',
                   'Inverted chevron', 'V panel', 'Bib', 'Side panels', 'Corner block',
                   'Half hoops', 'Thirds'];
  var USES_DENSITY = ['Hoops', 'Thin hoops', 'Wide hoops', 'Half hoops', 'Fade hoops',
                      'Stripes', 'Pinstripe', 'Grid', 'Checkerboard', 'Diamonds', 'Argyle',
                      'Dots', 'Honeycomb', 'Waves', 'Zigzag', 'Diagonal', 'Double diagonal'];
  var PRESETS = [
    ['#0B3B24', '#C69A22'], ['#1A3FA8', '#F2F0EA'], ['#8E1B2B', '#F2EDE2'],
    ['#101418', '#C8A02A'], ['#0E6C6C', '#F4A21B'], ['#E4E2DC', '#0B2E63']
  ];

  function $(id) { return document.getElementById(id); }
  function hex(h) {
    return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
  }
  function toHex(a) {
    return '#' + a.map(function (v) {
      return ('0' + Math.max(0, Math.min(255, Math.round(v))).toString(16)).slice(-2);
    }).join('').toUpperCase();
  }
  function isKit() { return !!G.kit; }
  function side() { return isKit() ? 'front' : (VIEWS[V].side || 'front'); }
  function totalQty() { var t = 0; for (var k in QTY) t += QTY[k] || 0; return t; }

  /* ---------- data parts ---------- */
  window.KB_DATA = function (name, map) {
    for (var k in map) A[k] = map[k];
    parts[name] = 'ready';
    (partCbs[name] || []).forEach(function (fn) { fn(); });
    partCbs[name] = [];
  };
  function ensureOne(name, cb) {
    if (!name || !CFG.parts || !CFG.parts[name] || parts[name] === 'ready') return cb();
    (partCbs[name] = partCbs[name] || []).push(cb);
    if (parts[name] === 'loading') return;
    parts[name] = 'loading';
    var sc = document.createElement('script');
    sc.src = CFG.parts[name];
    sc.onerror = function () { console.error('kit builder: could not load ' + name); };
    document.head.appendChild(sc);
  }
  function ensurePart(g, cb) {
    var names = g.parts || (g.part ? [g.part] : []);
    if (!names.length) return cb();
    var left = names.length;
    names.forEach(function (n) { ensureOne(n, function () { if (!--left) cb(); }); });
  }

  /* ---------- images ---------- */
  function load(key, cb) {
    if (imgs[key]) return cb(imgs[key]);
    var i = new Image();
    i.onload = function () { imgs[key] = i; cb(i); };
    i.onerror = function () { console.error('kit builder: asset failed ' + key); };
    i.src = A[key];
  }
  function pixels(key, w, h, cb) {
    if (cache[key]) return cb(cache[key]);
    load(key, function (i) {
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var g = c.getContext('2d'); g.drawImage(i, 0, 0, w, h);
      cache[key] = g.getImageData(0, 0, w, h).data;
      cb(cache[key]);
    });
  }
  function need(v, cb) {
    var d = VIEWS[v], got = 0, r = {};
    function fin() { if (++got === 2) cb(r); }
    pixels(d.shade, d.w, d.h, function (a) { r.s = a; fin(); });
    pixels(d.zone, d.w, d.h, function (a) { r.z = a; fin(); });
  }
  function loadBrand() {
    if (brandImg || !A.brand) return;
    var b = new Image();
    b.onload = function () { brandImg = b; render(); };
    b.src = A.brand;
  }

  /* ---------- pattern ---------- */
  function band(t, w) { return Math.abs(t) < w; }
  function fr(x) { return x - Math.floor(x); }
  function dither(u, v) {
    return ((Math.floor(u * 220) % 4) * 4 + (Math.floor(v * 220) % 4)) / 16;
  }
  function noise(u, v, f) {
    return (Math.sin(u * f * 12.9898 + v * f * 78.233) * 43758.5453) % 1;
  }
  function inPattern(u, v, n) {
    switch (PAT) {
      case 'Hoops':          return Math.floor(v * n) % 2 === 1;
      case 'Thin hoops':     return fr(v * n * 2) < 0.30;
      case 'Wide hoops':     return Math.floor(v * Math.max(2, n / 2)) % 2 === 1;
      case 'Half hoops':     return v > 0.46 && Math.floor((v - 0.46) * n * 1.6) % 2 === 0;
      case 'Fade hoops':     return Math.floor(v * n) % 2 === 1 && dither(u, v) > (v - 0.15) / 0.85;
      case 'Thirds':         return v > 0.34 && v < 0.67;
      case 'Chest band':     return v > 0.215 && v < 0.335;
      case 'Stripes':        return Math.floor(u * n) % 2 === 1;
      case 'Pinstripe':      return fr(u * n * 3) < 0.18;
      case 'Racing stripes': return band(u - 0.44, 0.026) || band(u - 0.56, 0.026);
      case 'Diamonds':       return Math.abs(fr(u * n) - 0.5) + Math.abs(fr(v * n) - 0.5) < 0.42;
      case 'Argyle':
        return (Math.abs(fr(u * n) - 0.5) + Math.abs(fr(v * n) - 0.5) < 0.40) ||
               band(fr(u * n + v * n) - 0.5, 0.035);
      case 'Dots': {
        var du = fr(u * n) - 0.5, dv = fr(v * n) - 0.5;
        return du * du + dv * dv < 0.075;
      }
      case 'Honeycomb': {
        var row = Math.floor(v * n);
        var off = (row % 2) * 0.5;
        var hu = Math.abs(fr(u * n + off) - 0.5), hv = Math.abs(fr(v * n) - 0.5);
        return hu + hv * 0.8 > 0.42;
      }
      case 'Waves':
        return band(v - (0.34 + 0.055 * Math.sin(u * n * 3)), 0.05) ||
               band(v - (0.66 + 0.055 * Math.sin(u * n * 3)), 0.05);
      case 'Camo': {
        var a1 = Math.sin(u * 11 + v * 17) + 0.8 * Math.sin(u * 19 - v * 7) +
                 0.5 * Math.sin(u * 23 + v * 17) + 0.35 * Math.sin(u * 31 - v * 29);
        return a1 > 0.30;
      }
      case 'Double diagonal':
        return fr((u + v) * n) < 0.22 || band(fr((u + v) * n) - 0.5, 0.11);
      case 'Grid':           return (u * n * 2) % 1 < 0.13 || (v * n * 2) % 1 < 0.13;
      case 'Diagonal':       return ((u + v) * n) % 1 < 0.5;
      case 'Checkerboard':   return (Math.floor(u * n) + Math.floor(v * n)) % 2 === 1;
      case 'Zigzag':
        return band(v - (0.30 + 0.10 * Math.abs(((u * n) % 2) - 1)), 0.045) ||
               band(v - (0.62 + 0.10 * Math.abs(((u * n) % 2) - 1)), 0.045);
      case 'Fade': {
        var d0 = ((Math.floor(u * 220) % 4) * 4 + (Math.floor(v * 220) % 4)) / 16;
        return d0 < (v - 0.28) / 0.6;
      }
      case 'Halves':         return u > 0.5;
      case 'Halves across':  return v > 0.5;
      case 'Quarters':       return (u > 0.5) !== (v > 0.5);
      case 'Sash':           return band((u - (v - 0.5) * 0.5) - 0.40, 0.075);
      case 'Reverse sash':   return band((u + (v - 0.5) * 0.5) - 0.60, 0.075);
      case 'Cross sash':
        return band((u - (v - 0.5) * 0.5) - 0.42, 0.055) ||
               band((u + (v - 0.5) * 0.5) - 0.58, 0.055);
      case 'Double sash':
        return band((u - (v - 0.5) * 0.5) - 0.34, 0.045) ||
               band((u - (v - 0.5) * 0.5) - 0.47, 0.045);
      case 'Chevron':        return band(v - (0.16 + Math.abs(u - 0.5) * 0.75), 0.055);
      case 'Inverted chevron': return band(v - (0.46 - Math.abs(u - 0.5) * 0.72), 0.055);
      case 'Double chevron':
        return band(v - (0.14 + Math.abs(u - 0.5) * 0.75), 0.038) ||
               band(v - (0.27 + Math.abs(u - 0.5) * 0.75), 0.038);
      case 'V panel':        return Math.abs(u - 0.5) < (0.30 - v * 0.22);
      case 'Bib':            return v < 0.44 && Math.abs(u - 0.5) < 0.30;
      case 'Side panels':    return Math.abs(u - 0.5) > 0.245;
      case 'Yoke':           return v < 0.20;
      case 'Shoulder flash': return v < 0.26 && Math.abs(u - 0.5) > 0.155;
      case 'Corner block':   return v < 0.40 && u > 0.56;
      default:               return false;
    }
  }

  /* ---------- arc text ---------- */
  function arcText(g, text, cxp, cyp, radius, font, colour) {
    g.save();
    g.font = font; g.fillStyle = colour;
    g.textAlign = 'center'; g.textBaseline = 'middle';
    var total = 0, widths = [];
    for (var i = 0; i < text.length; i++) {
      var w = g.measureText(text[i]).width; widths.push(w); total += w;
    }
    var ang = total / radius, start = -ang / 2, acc = 0;
    for (var j = 0; j < text.length; j++) {
      var a = start + (acc + widths[j] / 2) / radius;
      acc += widths[j];
      g.save();
      g.translate(cxp + Math.sin(a) * radius, cyp - Math.cos(a) * radius + radius);
      g.rotate(a);
      g.fillText(text[j], 0, 0);
      g.restore();
    }
    g.restore();
  }

  /* ---------- composite one view ---------- */
  function composite(v, target, cb) {
    var d = VIEWS[v];
    target.width = d.w; target.height = d.h;
    var tx = target.getContext('2d');
    need(v, function (M) {
      var out = tx.createImageData(d.w, d.h), o = out.data;
      var S = M.s, Z = M.z, blend = 0.85;
      var patZones = d.patternZones || [1], n = DENSITY;
      // halves, quarters, sashes and chevrons are body graphics — a screen-space
      // split across a sleeve reads as a mistake, so keep them off zone 2
      if (BODY_ONLY.indexOf(PAT) > -1) patZones = [1];

      /* per-template exposure: the source mockups differ in how dark their
         shading passes are, so a colour lands differently on each garment.
         gamma brings them onto a common mid-tone without clipping. */
      var gam = d.gamma || 1, LUT = null;
      if (gam !== 1) {
        LUT = new Uint8Array(256);
        for (var g0 = 0; g0 < 256; g0++)
          LUT[g0] = Math.max(0, Math.min(255, Math.round(255 * Math.pow(g0 / 255, 1 / gam))));
      }

      for (var y = 0, i = 0; y < d.h; y++) {
        for (var x = 0; x < d.w; x++, i++) {
          var p = i * 4, a = Z[p + 3];
          if (a < 8) { o[p + 3] = 0; continue; }
          var z = Math.round(Z[p] / 30), t = COL[z];
          if (!t) { o[p + 3] = 0; continue; }
          if (PAT !== 'Solid' && patZones.indexOf(z) > -1 && inPattern(x / d.w, y / d.h, n)) t = PATCOL;
          var r = t[0], g = t[1], b2 = t[2];
          if (d.mode === 'lb') {
            var SH = S[p], HI = S[p + 1];
            r += SH - 255; g += SH - 255; b2 += SH - 255;
            if (r < 0) r = 0; if (g < 0) g = 0; if (b2 < 0) b2 = 0;
            r  = 255 - (255 - r)  * (255 - HI) / 255;
            g  = 255 - (255 - g)  * (255 - HI) / 255;
            b2 = 255 - (255 - b2) * (255 - HI) / 255;
          } else {
            var Mu = S[p], Sc = S[p + 1], Ov = S[p + 2];
            r  = 255 - (255 - r)  * (255 - Sc) / 255;
            g  = 255 - (255 - g)  * (255 - Sc) / 255;
            b2 = 255 - (255 - b2) * (255 - Sc) / 255;
            r  = r  < 128 ? 2 * r  * Ov / 255 : 255 - 2 * (255 - r)  * (255 - Ov) / 255;
            g  = g  < 128 ? 2 * g  * Ov / 255 : 255 - 2 * (255 - g)  * (255 - Ov) / 255;
            b2 = b2 < 128 ? 2 * b2 * Ov / 255 : 255 - 2 * (255 - b2) * (255 - Ov) / 255;
            r = r * Mu / 255; g = g * Mu / 255; b2 = b2 * Mu / 255;
          }
          r  = r  < 0 ? 0 : r  > 255 ? 255 : r;
          g  = g  < 0 ? 0 : g  > 255 ? 255 : g;
          b2 = b2 < 0 ? 0 : b2 > 255 ? 255 : b2;
          if (LUT) { r = LUT[r | 0]; g = LUT[g | 0]; b2 = LUT[b2 | 0]; }
          o[p] = r; o[p + 1] = g; o[p + 2] = b2; o[p + 3] = a;
        }
      }

      /* everything printed on the garment goes through here so it picks up the shading */
      function stampLayer(drawFn, blendMul) {
        var lc = document.createElement('canvas'); lc.width = d.w; lc.height = d.h;
        var lg = lc.getContext('2d');
        drawFn(lg);
        var L = lg.getImageData(0, 0, d.w, d.h).data;
        for (var k = 0; k < d.w * d.h; k++) {
          var q = k * 4, la = L[q + 3] / 255;
          if (la < 0.01 || Z[q + 3] < 8 || Math.round(Z[q] / 30) === 0) continue;
          var sh = d.mode === 'lb'
            ? Math.min(1.6, S[q] / 255 + (S[q + 1] / 255) * 0.7)
            : (S[q] / 255) * (1 + (S[q + 1] / 255) * 0.6);
          sh = 1 + (Math.min(sh, 1.5) - 1) * blend * (blendMul === undefined ? 1 : blendMul);
          for (var ch = 0; ch < 3; ch++) {
            var val = L[q + ch] * sh; if (val < 0) val = 0; if (val > 255) val = 255;
            o[q + ch] = o[q + ch] * (1 - la) + val * la;
          }
        }
      }
      function stampTinted(img, cx0, cy0, wf, tint) {
        var lw = wf * d.w, lh = lw * img.height / img.width;
        var lc = document.createElement('canvas'); lc.width = d.w; lc.height = d.h;
        var lg = lc.getContext('2d');
        lg.drawImage(img, cx0 * d.w - lw / 2, cy0 * d.h - lh / 2, lw, lh);
        var L = lg.getImageData(0, 0, d.w, d.h).data;
        for (var k = 0; k < d.w * d.h; k++) {
          var q = k * 4, la = L[q + 3] / 255;
          if (la < 0.01 || Z[q + 3] < 8 || Math.round(Z[q] / 30) === 0) continue;
          var sh = d.mode === 'lb'
            ? Math.min(1.6, S[q] / 255 + (S[q + 1] / 255) * 0.7)
            : (S[q] / 255) * (1 + (S[q + 1] / 255) * 0.6);
          sh = 1 + (Math.min(sh, 1.5) - 1) * blend;
          for (var ch = 0; ch < 3; ch++) {
            var src = tint ? tint[ch] : L[q + ch];
            var val = src * sh; if (val < 0) val = 0; if (val > 255) val = 255;
            o[q + ch] = o[q + ch] * (1 - la) + val * la;
          }
        }
      }

      if (brandImg && d.brand)
        stampTinted(brandImg, d.brand[0], d.brand[1], d.brand[2], hex($('brandC').value));

      var sd = d.side || 'front';
      SLOTS.forEach(function (s) {
        if (s.img && s.side === sd) stampTinted(s.img, s.x, s.y, s.size / 100, null);
      });

      /* name and number */
      var nm = ($('pName') ? $('pName').value : '').toUpperCase().slice(0, 14);
      var num = ($('pNum') ? $('pNum').value : '').replace(/\D/g, '').slice(0, 2);
      var tc = $('textC') ? $('textC').value : '#FFFFFF';
      if (d.nameY && (nm || num)) {
        stampLayer(function (lg) {
          if (nm) {
            arcText(lg, nm, d.w * 0.5, d.h * d.nameY, d.w * 1.9,
                    textFont(d.h * 0.052, '400'), tc);
          }
          if (num) {
            lg.save();
            lg.fillStyle = tc; lg.textAlign = 'center'; lg.textBaseline = 'middle';
            lg.font = textFont(d.h * 0.215, '400');
            lg.fillText(num, d.w * 0.5, d.h * d.numY);
            lg.restore();
          }
        }, 0.4);
      }

      tx.putImageData(out, 0, 0);

      SLOTS.forEach(function (s) {
        if (!s.file || s.img || s.side !== sd) return;
        var w = (s.size / 100) * d.w, h = w * 0.42;
        tx.save();
        tx.strokeStyle = 'rgba(20,20,20,.75)'; tx.setLineDash([7, 5]); tx.lineWidth = 2;
        tx.strokeRect(s.x * d.w - w / 2, s.y * d.h - h / 2, w, h);
        tx.setLineDash([]);
        tx.fillStyle = 'rgba(20,20,20,.75)';
        tx.font = '500 13px Helvetica, Arial, sans-serif';
        tx.textAlign = 'center'; tx.textBaseline = 'middle';
        tx.fillText(s.label, s.x * d.w, s.y * d.h - 8);
        tx.font = '400 11px Helvetica, Arial, sans-serif';
        tx.fillText('vector supplied', s.x * d.w, s.y * d.h + 9);
        tx.restore();
      });

      if (cb) cb(target);
    });
  }

  /* ---------- composite the whole kit side by side ---------- */
  function compositeKit(target, cb) {
    var views = G.kit, shots = [], left = views.length;
    views.forEach(function (v, i) {
      var t = document.createElement('canvas');
      composite(v, t, function () { shots[i] = t; if (!--left) lay(); });
    });
    function lay() {
      var gap = 40, H = 980;
      var scaled = shots.map(function (s) {
        var sc = Math.min(H / s.height, 1.15);
        return { c: s, w: s.width * sc, h: s.height * sc };
      });
      var W = scaled.reduce(function (a, s) { return a + s.w; }, 0) + gap * (scaled.length - 1);
      target.width = Math.round(W); target.height = H;
      var g = target.getContext('2d');
      g.clearRect(0, 0, target.width, target.height);
      var x = 0;
      scaled.forEach(function (s) {
        g.drawImage(s.c, Math.round(x), Math.round(H - s.h), Math.round(s.w), Math.round(s.h));
        x += s.w + gap;
      });
      if (cb) cb(target);
    }
  }

  var pending = false;
  function queue() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; render(); });
  }
  function render() {
    loadBrand();
    if (isKit()) compositeKit(cv, updateBar);
    else composite(V, cv, updateBar);
  }

  /* ---------- sticky bar (mobile) ---------- */
  var bar = $('kbBar'), thumb = $('kbThumb');
  function updateBar() {
    if (!bar) return;
    var nm = $('kbBarName'); if (nm) nm.textContent = G.name;
    var q = $('kbBarQty');
    if (q) {
      var t = totalQty();
      q.textContent = t ? t + ' garment' + (t === 1 ? '' : 's') : 'No sizes yet';
    }
    if (!thumb || !cv.width) return;
    var tx = thumb.getContext('2d');
    tx.clearRect(0, 0, thumb.width, thumb.height);
    var sc = Math.min(thumb.width / cv.width, thumb.height / cv.height);
    var w = cv.width * sc, h = cv.height * sc;
    tx.drawImage(cv, (thumb.width - w) / 2, thumb.height - h, w, h);
  }
  if (bar) {
    var goBtn = $('kbBarGo');
    if (goBtn) goBtn.onclick = function () {
      var f = $('kb-form') || $('send');
      if (f && f.scrollIntoView) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = $('fN'); if (first) setTimeout(function () { first.focus(); }, 500);
    };
    var stage = document.querySelector('.kb__stage');
    var formEl = $('kb-form');
    var stageOut = false, formIn = false;
    var sync = function () { bar.hidden = !(stageOut && !formIn); };
    if (stage && window.IntersectionObserver) {
      new IntersectionObserver(function (es) {
        stageOut = es[0].intersectionRatio < 0.12; sync();
      }, { threshold: [0, 0.12, 0.5] }).observe(stage);
      if (formEl) {
        new IntersectionObserver(function (es) {
          formIn = es[0].isIntersecting; sync();
        }, { threshold: 0.15 }).observe(formEl);
      }
    } else if (stage) {
      window.addEventListener('scroll', function () {
        var r = stage.getBoundingClientRect();
        stageOut = r.bottom < 60;
        if (formEl) { var fr = formEl.getBoundingClientRect(); formIn = fr.top < window.innerHeight && fr.bottom > 0; }
        sync();
      }, { passive: true });
    }
  }

  /* ---------- crest palette extraction ---------- */
  function extractPalette(img, k) {
    var N = 90, c = document.createElement('canvas');
    var sc = Math.min(N / img.width, N / img.height, 1);
    c.width = Math.max(1, Math.round(img.width * sc));
    c.height = Math.max(1, Math.round(img.height * sc));
    var g = c.getContext('2d');
    g.drawImage(img, 0, 0, c.width, c.height);
    var d;
    try { d = g.getImageData(0, 0, c.width, c.height).data; } catch (e) { return []; }
    var pts = [];
    for (var i = 0; i < c.width * c.height; i++) {
      var p = i * 4;
      if (d[p + 3] < 140) continue;
      var r = d[p], gg = d[p + 1], b = d[p + 2];
      var mx = Math.max(r, gg, b), mn = Math.min(r, gg, b);
      if (mx > 244 && mx - mn < 14) continue;      // paper white
      if (mx < 26) continue;                        // near black
      pts.push([r, gg, b]);
    }
    if (pts.length < 12) return [];
    k = Math.min(k || 4, 6);
    var cent = [];
    for (var j = 0; j < k; j++) cent.push(pts[Math.floor(pts.length * (j + 0.5) / k)].slice());
    for (var it = 0; it < 12; it++) {
      var sums = [], counts = [];
      for (var a = 0; a < k; a++) { sums.push([0, 0, 0]); counts.push(0); }
      for (var q = 0; q < pts.length; q++) {
        var best = 0, bd = Infinity;
        for (var m = 0; m < k; m++) {
          var dr = pts[q][0] - cent[m][0], dg = pts[q][1] - cent[m][1], db = pts[q][2] - cent[m][2];
          var dist = dr * dr + dg * dg + db * db;
          if (dist < bd) { bd = dist; best = m; }
        }
        sums[best][0] += pts[q][0]; sums[best][1] += pts[q][1]; sums[best][2] += pts[q][2];
        counts[best]++;
      }
      for (var n2 = 0; n2 < k; n2++) {
        if (!counts[n2]) continue;
        cent[n2] = [sums[n2][0] / counts[n2], sums[n2][1] / counts[n2], sums[n2][2] / counts[n2]];
      }
    }
    var out = [];
    cent.forEach(function (c2) {
      var h = toHex(c2);
      var dup = out.some(function (o) {
        return Math.abs(hex(o)[0] - c2[0]) + Math.abs(hex(o)[1] - c2[1]) + Math.abs(hex(o)[2] - c2[2]) < 46;
      });
      if (!dup) out.push(h);
    });
    return out.slice(0, 5);
  }
  function showPalette(list) {
    var w = $('crestPal'), grp = $('crestPalGrp');
    if (!w || !grp) return;
    w.innerHTML = '';
    if (!list.length) { grp.hidden = true; return; }
    grp.hidden = false;
    list.forEach(function (h, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'kb__chip';
      b.style.background = h;
      b.setAttribute('aria-label', 'Use ' + h);
      b.title = h;
      b.onclick = function () {
        var other = list[(i + 1) % list.length] || '#F2F0EA';
        applyPair(h, other);
      };
      w.appendChild(b);
    });
    var pair = document.createElement('button');
    pair.type = 'button'; pair.className = 'btn btn--ghost btn--sm';
    pair.textContent = 'Use these colours';
    pair.onclick = function () { applyPair(list[0], list[1] || '#F2F0EA'); };
    w.appendChild(pair);
  }
  function applyPair(main, trim) {
    G.zones.forEach(function (zn) {
      var c;
      if (zn[0] === 2) c = LINKSLV ? main : trim;
      else c = (zn[0] === 1 || zn[0] === 6) ? main : trim;
      COL[zn[0]] = hex(c);
      var el = $('zc' + zn[0]); if (el) el.value = c;
    });
    PATCOL = hex(trim); if ($('patC')) $('patC').value = trim;
    render();
  }

  /* ---------- size grid ---------- */
  function buildSizes() {
    var w = $('sizes'); if (!w) return;
    w.innerHTML = '';
    SIZES.forEach(function (sz) {
      var cell = document.createElement('div');
      cell.className = 'kb__size';
      var lab = document.createElement('label');
      lab.textContent = sz; lab.htmlFor = 'q_' + sz;
      var inp = document.createElement('input');
      inp.type = 'number'; inp.min = '0'; inp.step = '1'; inp.id = 'q_' + sz;
      inp.inputMode = 'numeric';
      inp.value = QTY[sz] ? QTY[sz] : '';
      inp.placeholder = '0';
      inp.oninput = function () {
        var n = parseInt(inp.value, 10);
        QTY[sz] = isNaN(n) || n < 0 ? 0 : n;
        syncTotal(); updateBar();
      };
      cell.appendChild(lab); cell.appendChild(inp); w.appendChild(cell);
    });
    syncTotal();
  }
  function syncTotal() {
    var t = totalQty(), el = $('qtyTotal');
    if (el) el.textContent = t;
    var moq = CFG.moq || 0, warn = $('moqWarn');
    if (warn) warn.hidden = !(moq && t > 0 && t < moq);
  }

  /* ---------- share link ---------- */
  function encodeState() {
    var c = {};
    G.zones.forEach(function (zn) {
      var e = $('zc' + zn[0]); if (e) c[zn[0]] = e.value.replace('#', '');
    });
    var q = {};
    for (var k in QTY) if (QTY[k]) q[k] = QTY[k];
    var st = {
      g: G.id, v: V, p: PAT, n: DENSITY,
      pc: $('patC').value.replace('#', ''), c: c,
      b: { s: 1, c: $('brandC').value.replace('#', '') },
      t: { n: $('pName') ? $('pName').value : '', u: $('pNum') ? $('pNum').value : '',
           c: $('textC') ? $('textC').value.replace('#', '') : 'FFFFFF' },
      q: q
    };
    return btoa(unescape(encodeURIComponent(JSON.stringify(st))))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function decodeState(s) {
    try {
      var b = s.replace(/-/g, '+').replace(/_/g, '/');
      while (b.length % 4) b += '=';
      return JSON.parse(decodeURIComponent(escape(atob(b))));
    } catch (e) { return null; }
  }
  function applyState(st, done) {
    var g = GARMENTS.filter(function (x) { return x.id === st.g; })[0];
    if (!g) return done();
    ensurePart(g, function () {
      G = g;
      V = (st.v && VIEWS[st.v] && G.views.indexOf(st.v) > -1) ? st.v : G.views[0];
      PAT = PATTERNS.indexOf(st.p) > -1 ? st.p : 'Solid';
      DENSITY = st.n || 7;
      buildGarments(); buildZones(); buildViews();
      if (st.c) {
        G.zones.forEach(function (zn) {
          var v = st.c[zn[0]]; if (!v) return;
          var e = $('zc' + zn[0]);
          if (e) { e.value = '#' + v; COL[zn[0]] = hex('#' + v); }
        });
      }
      if (st.pc) { $('patC').value = '#' + st.pc; PATCOL = hex('#' + st.pc); }
      if (st.b) {
        if (st.b.c) $('brandC').value = '#' + st.b.c;
      }
      if (st.t) {
        if ($('pName')) $('pName').value = st.t.n || '';
        if ($('pNum')) $('pNum').value = st.t.u || '';
        if ($('textC') && st.t.c) $('textC').value = '#' + st.t.c;
      }
      QTY = {};
      if (st.q) for (var k in st.q) QTY[k] = st.q[k];
      $('density').value = DENSITY; $('densityO').textContent = DENSITY;
      buildSizes(); buildArt(); syncPats();
      done();
    });
  }
  function shareUrl() { return location.origin + location.pathname + '?d=' + encodeState(); }

  /* ---------- spec sheet ---------- */
  function buildSpecSheet(cb) {
    var W = 1240, H = 1754;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var g = c.getContext('2d');
    g.fillStyle = '#FBFAF6'; g.fillRect(0, 0, W, H);
    var views = isKit() ? G.kit : G.views;
    var shots = [], left = views.length;
    views.forEach(function (v, idx) {
      var tmp = document.createElement('canvas');
      composite(v, tmp, function () { shots[idx] = { view: v, canvas: tmp }; if (!--left) draw(); });
    });
    function line(y) {
      g.strokeStyle = '#E0DCD0'; g.lineWidth = 1;
      g.beginPath(); g.moveTo(60, y); g.lineTo(W - 60, y); g.stroke();
    }
    function draw() {
      var d = spec(), y = 78;
      g.fillStyle = '#16181A';
      g.font = '600 30px Helvetica, Arial, sans-serif';
      g.fillText('NELY SPORTS', 60, y);
      g.font = '400 15px Helvetica, Arial, sans-serif'; g.fillStyle = '#6B7075';
      g.fillText('Kit specification  \u00b7  ' + new Date().toLocaleDateString('en-IE'), 60, y + 26);
      g.textAlign = 'right';
      g.fillText(d.club || d.name || '', W - 60, y);
      g.fillText(d.email || '', W - 60, y + 22);
      g.fillText(d.phone || '', W - 60, y + 42);
      g.textAlign = 'left';
      y += 60; line(y); y += 44;
      g.fillStyle = '#16181A'; g.font = '600 22px Helvetica, Arial, sans-serif';
      g.fillText(d.garment, 60, y);
      g.font = '400 15px Helvetica, Arial, sans-serif'; g.fillStyle = '#6B7075';
      g.fillText(d.pattern + (d.patternColour ? '  \u00b7  pattern ' + d.patternColour : '') +
                 (d.pattern !== 'Solid' ? '  \u00b7  repeat ' + d.patternDensity : ''), 60, y + 24);
      y += 54;
      var maxH = 470, gap = 26;
      var each = (W - 120 - gap * (shots.length - 1)) / shots.length, top = y;
      shots.forEach(function (s, i) {
        var sc = Math.min(each / s.canvas.width, maxH / s.canvas.height);
        var w = s.canvas.width * sc, h = s.canvas.height * sc;
        g.drawImage(s.canvas, 60 + i * (each + gap) + (each - w) / 2, top + (maxH - h), w, h);
        g.fillStyle = '#6B7075'; g.font = '400 13px Helvetica, Arial, sans-serif';
        g.textAlign = 'center';
        g.fillText(VIEWS[s.view].label, 60 + i * (each + gap) + each / 2, top + maxH + 24);
        g.textAlign = 'left';
      });
      y = top + maxH + 54; line(y); y += 40;
      g.fillStyle = '#16181A'; g.font = '600 14px Helvetica, Arial, sans-serif';
      g.fillText('COLOURS', 60, y); y += 26;
      var cxp = 60;
      Object.keys(d.colours).forEach(function (k) {
        g.fillStyle = d.colours[k]; g.fillRect(cxp, y, 34, 34);
        g.strokeStyle = '#E0DCD0'; g.strokeRect(cxp + 0.5, y + 0.5, 33, 33);
        g.fillStyle = '#16181A'; g.font = '400 13px Helvetica, Arial, sans-serif';
        g.fillText(k, cxp + 44, y + 15);
        g.fillStyle = '#6B7075'; g.font = '400 12px Helvetica, Arial, sans-serif';
        g.fillText(d.colours[k].toUpperCase(), cxp + 44, y + 30);
        cxp += 200; if (cxp > W - 200) { cxp = 60; y += 48; }
      });
      y += 70; line(y); y += 40;
      g.fillStyle = '#16181A'; g.font = '600 14px Helvetica, Arial, sans-serif';
      g.fillText('SIZES', 60, y); y += 24;
      var sx = 60, keys = SIZES.filter(function (s) { return QTY[s]; });
      if (!keys.length) {
        g.fillStyle = '#6B7075'; g.font = '400 14px Helvetica, Arial, sans-serif';
        g.fillText('Not yet specified', 60, y + 18); y += 34;
      } else {
        keys.forEach(function (k) {
          g.strokeStyle = '#E0DCD0'; g.strokeRect(sx + 0.5, y + 0.5, 92, 56);
          g.fillStyle = '#6B7075'; g.font = '400 12px Helvetica, Arial, sans-serif';
          g.textAlign = 'center'; g.fillText(k, sx + 46, y + 20);
          g.fillStyle = '#16181A'; g.font = '600 20px Helvetica, Arial, sans-serif';
          g.fillText(String(QTY[k]), sx + 46, y + 44);
          g.textAlign = 'left'; sx += 100;
          if (sx > W - 160) { sx = 60; y += 66; }
        });
        y += 74;
        g.fillStyle = '#16181A'; g.font = '600 15px Helvetica, Arial, sans-serif';
        g.fillText('Total  ' + totalQty(), 60, y); y += 20;
      }
      y += 24; line(y); y += 40;
      g.fillStyle = '#16181A'; g.font = '600 14px Helvetica, Arial, sans-serif';
      g.fillText('ARTWORK AND PERSONALISATION', 60, y); y += 26;
      g.font = '400 13px Helvetica, Arial, sans-serif';
      if (!d.artwork.length) { g.fillStyle = '#6B7075'; g.fillText('No artwork supplied', 60, y); y += 22; }
      else d.artwork.forEach(function (a) {
        g.fillStyle = '#16181A'; g.fillText(a.slot + '  (' + a.view + ')', 60, y);
        g.fillStyle = '#6B7075';
        g.fillText((a.file || 'file') + '   x ' + a.x + '  y ' + a.y + '  width ' + a.size +
                   (a.vector ? '   vector' : '   raster'), 320, y);
        y += 22;
      });
      if (d.playerName || d.playerNumber) {
        g.fillStyle = '#16181A'; g.fillText('Back print', 60, y);
        g.fillStyle = '#6B7075';
        g.fillText([d.playerName, d.playerNumber].filter(Boolean).join('   no. ') +
                   '   in ' + d.textColour, 320, y);
        y += 22;
      }
      y += 24;
      g.fillStyle = '#6B7075'; g.font = '400 12px Helvetica, Arial, sans-serif';
      g.fillText('NELY mark: ' + (d.nelyMark.shown ? d.nelyMark.colour : 'not applied') +
                 '   \u00b7   Positions are fractions of the garment view, from top left.', 60, y);
      y += 20;
      g.fillText('Generated by the NelySports kit builder. Colours are on-screen values and should be', 60, y);
      g.fillText('confirmed against physical swatches before production.', 60, y + 16);
      cb(c.toDataURL('image/png'));
    }
  }

  /* ---------- artwork slots ---------- */
  function slotsForSide() {
    var sd = side();
    return SLOTS.filter(function (s) { return s.side === sd; });
  }
  function setActive(s) {
    ACTIVE = s;
    $('sz').value = s.size; $('szO').textContent = s.size;
    buildArt();
  }
  function buildArt() {
    var w = $('art'); if (!w) return;
    w.innerHTML = '';
    var sd = side();
    SLOTS.forEach(function (s) {
      var row = document.createElement('div');
      row.className = 'kb__art-row';
      row.setAttribute('aria-pressed', s === ACTIVE);
      if (s.side !== sd) row.className += ' is-other';
      var head = document.createElement('div');
      head.className = 'kb__art-head';
      var lab = document.createElement('b');
      lab.textContent = s.label + (s.side !== sd ? ' \u2014 ' + s.side + ' view' : '');
      head.appendChild(lab);
      if (s.file) {
        var rm = document.createElement('button');
        rm.type = 'button'; rm.className = 'kb__art-rm'; rm.textContent = 'Remove';
        rm.onclick = function (ev) {
          ev.stopPropagation();
          s.img = null; s.file = null;
          var i0 = $('f_' + s.id); if (i0) i0.value = '';
          if (s.id === 'crest') showPalette([]);
          buildArt(); render();
        };
        head.appendChild(rm);
      }
      row.appendChild(head);
      var inp = document.createElement('input');
      inp.type = 'file'; inp.id = 'f_' + s.id;
      inp.accept = '.png,.jpg,.jpeg,.svg,.pdf,.ai,.eps,image/png,image/jpeg,image/svg+xml,application/pdf';
      inp.onchange = function (ev) {
        var f = ev.target.files[0]; if (!f) return;
        s.file = f;
        if (!RASTER.test(f.name)) { s.img = null; gotoSide(s); setActive(s); render(); return; }
        var rd = new FileReader();
        rd.onload = function () {
          var im = new Image();
          im.onload = function () {
            s.img = im;
            if (s.id === 'crest') showPalette(extractPalette(im, 4));
            gotoSide(s); setActive(s); render();
          };
          im.onerror = function () { s.img = null; gotoSide(s); setActive(s); render(); };
          im.src = rd.result;
        };
        rd.readAsDataURL(f);
      };
      row.appendChild(inp);
      if (s.file && !s.img) {
        var note = document.createElement('p');
        note.className = 'kb__art-note';
        note.textContent = 'Print-ready vector received. Shown as a placement box \u2014 upload a PNG too if you want to see it on the garment.';
        row.appendChild(note);
      }
      row.onclick = function () { if (s.file) setActive(s); };
      w.appendChild(row);
    });
  }
  function gotoSide(s) {
    if (isKit() || s.side === side()) return;
    for (var i = 0; i < G.views.length; i++) {
      if ((VIEWS[G.views[i]].side || 'front') === s.side) { V = G.views[i]; buildViews(); return; }
    }
  }

  /* ---------- UI ---------- */
  function buildGarments() {
    var w = $('garments'); w.innerHTML = '';
    GARMENTS.forEach(function (g) {
      var b = document.createElement('button');
      b.className = 'tile'; b.type = 'button';
      if (g.kit) b.className += ' tile--kit';
      b.setAttribute('aria-pressed', g === G);
      b.innerHTML = '<b></b><i></i>';
      b.firstChild.textContent = g.name;
      b.lastChild.textContent = g.sub;
      b.onclick = function () {
        ensurePart(g, function () {
          var prev = COL;
          G = g; V = g.views[0];
          buildGarments(); buildZones();
          G.zones.forEach(function (zn) {
            if (prev[zn[0]]) {
              COL[zn[0]] = prev[zn[0]];
              var e = $('zc' + zn[0]); if (e) e.value = toHex(prev[zn[0]]);
            }
          });
          buildViews(); buildArt(); render();
        });
      };
      w.appendChild(b);
    });
  }
  function buildViews() {
    var w = $('views'); w.innerHTML = '';
    if (isKit()) return;
    G.views.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = VIEWS[v].label;
      b.setAttribute('aria-pressed', v === V);
      b.onclick = function () {
        V = v; buildViews();
        var here = slotsForSide().filter(function (s) { return s.file; });
        if (here.length) setActive(here[0]); else buildArt();
        render();
      };
      w.appendChild(b);
    });
  }
  function buildZones() {
    var w = $('swatches'); w.innerHTML = ''; COL = {};
    var body = null, slv = null;
    G.zones.forEach(function (zn) {
      if (zn[0] === 1) body = zn[2];
      if (zn[0] === 2) slv = zn[2];
    });
    // link only when the template ships them the same; contrast raglans stay independent
    LINKSLV = !!(body && slv && body.toUpperCase() === slv.toUpperCase());

    G.zones.forEach(function (zn) {
      COL[zn[0]] = hex(zn[2]);
      var row = document.createElement('div'); row.className = 'kb__sw';
      var inp = document.createElement('input');
      inp.type = 'color'; inp.value = zn[2]; inp.id = 'zc' + zn[0];
      inp.oninput = function () {
        COL[zn[0]] = hex(inp.value);
        if (zn[0] === 1 && LINKSLV) {
          var s2 = $('zc2');
          if (s2) { s2.value = inp.value; COL[2] = hex(inp.value); }
        }
        if (zn[0] === 2 && LINKSLV) {
          LINKSLV = false;
          var cb0 = $('linkSlv'); if (cb0) cb0.checked = false;
        }
        queue();
      };
      var lab = document.createElement('label');
      lab.textContent = zn[1]; lab.htmlFor = inp.id;
      row.appendChild(inp); row.appendChild(lab);

      if (zn[0] === 2 && body) {
        var lk = document.createElement('label');
        lk.className = 'kb__link';
        var cb = document.createElement('input');
        cb.type = 'checkbox'; cb.id = 'linkSlv'; cb.checked = LINKSLV;
        cb.onchange = function () {
          LINKSLV = cb.checked;
          if (LINKSLV) {
            var b = $('zc1'), s2 = $('zc2');
            if (b && s2) { s2.value = b.value; COL[2] = hex(b.value); }
          }
          queue();
        };
        lk.appendChild(cb);
        lk.appendChild(document.createTextNode('Match body'));
        row.appendChild(lk);
      }
      w.appendChild(row);
    });
  }
  function buildPatterns() {
    var w = $('pats'); w.innerHTML = '';
    PATTERNS.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = p;
      b.setAttribute('aria-pressed', p === PAT);
      b.onclick = function () { PAT = p; syncPats(); queue(); };
      w.appendChild(b);
    });
  }
  function syncPats() {
    [].forEach.call($('pats').children, function (c) {
      c.setAttribute('aria-pressed', c.textContent === PAT);
    });
    $('densityRow').style.display = USES_DENSITY.indexOf(PAT) > -1 ? '' : 'none';
  }
  function buildPresets() {
    var w = $('presets'); w.innerHTML = '';
    PRESETS.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pre';
      b.setAttribute('aria-label', 'Apply ' + p[0] + ' with ' + p[1]);
      b.innerHTML = '<s class="a"></s><s class="b"></s>';
      b.firstChild.style.background = p[0];
      b.lastChild.style.background = p[1];
      b.onclick = function () { applyPair(p[0], p[1]); };
      w.appendChild(b);
    });
  }
  function shuffle() {
    var pool = PRESETS;
    var p = pool[Math.floor(Math.random() * pool.length)];
    PAT = PATTERNS[1 + Math.floor(Math.random() * (PATTERNS.length - 1))];
    DENSITY = 5 + Math.floor(Math.random() * 9);
    $('density').value = DENSITY; $('densityO').textContent = DENSITY;
    if (Math.random() < 0.4) { var t = p[0]; p = [p[1], t]; }
    syncPats(); applyPair(p[0], p[1]);
  }

  /* ---------- inputs ---------- */
  $('patC').addEventListener('input', function (e) { PATCOL = hex(e.target.value); queue(); });
  $('density').addEventListener('input', function (e) {
    DENSITY = +e.target.value; $('densityO').textContent = e.target.value; queue();
  });
  $('sz').addEventListener('input', function (e) {
    ACTIVE.size = +e.target.value; $('szO').textContent = e.target.value; queue();
  });
  $('brandC').addEventListener('input', queue);
  ['pName', 'pNum', 'textC'].forEach(function (id) {
    var el = $(id);
    if (el) { el.addEventListener('input', queue); el.addEventListener('change', queue); }
  });
  var shuf = $('shuffle'); if (shuf) shuf.onclick = shuffle;

  function pos(e) {
    var r = cv.getBoundingClientRect(), c = e.touches ? e.touches[0] : e;
    ACTIVE.x = (c.clientX - r.left) / r.width;
    ACTIVE.y = (c.clientY - r.top) / r.height;
    queue();
  }
  function canDrag() { return !isKit() && ACTIVE && ACTIVE.file && ACTIVE.side === side(); }
  cv.addEventListener('mousedown', function (e) { if (canDrag()) { drag = true; pos(e); } });
  window.addEventListener('mousemove', function (e) { if (drag) pos(e); });
  window.addEventListener('mouseup', function () { drag = false; });
  cv.addEventListener('touchstart', function (e) {
    if (canDrag()) { drag = true; pos(e); e.preventDefault(); }
  }, { passive: false });
  cv.addEventListener('touchmove', function (e) {
    if (drag) { pos(e); e.preventDefault(); }
  }, { passive: false });
  window.addEventListener('touchend', function () { drag = false; });

  $('dl').onclick = function () {
    var a = document.createElement('a');
    a.download = 'nelysports-' + G.id + '.png';
    a.href = cv.toDataURL('image/png'); a.click();
  };
  var sheetBtn = $('sheet');
  if (sheetBtn) sheetBtn.onclick = function () {
    buildSpecSheet(function (url) {
      var a = document.createElement('a');
      a.download = 'nelysports-spec-' + G.id + '.png';
      a.href = url; a.click();
    });
  };
  var shareBtn = $('share');
  if (shareBtn) shareBtn.onclick = function () {
    var url = shareUrl(), note = $('shareMsg');
    function done(ok) {
      if (!note) return;
      note.hidden = false;
      note.textContent = ok ? 'Link copied \u2014 send it to anyone.' : url;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { done(true); }, function () { done(false); });
    } else done(false);
    if (history.replaceState) history.replaceState(null, '', '?d=' + encodeState());
  };

  /* ---------- submission ---------- */
  function spec() {
    var cols = {};
    G.zones.forEach(function (zn) {
      var e = $('zc' + zn[0]);
      cols[zn[1].toLowerCase()] = e ? e.value : zn[2];
    });
    var sizes = {};
    SIZES.forEach(function (s) { if (QTY[s]) sizes[s] = QTY[s]; });
    return {
      name: $('fN').value, club: $('fC').value, email: $('fE').value, phone: $('fP').value,
      garment: G.name, garmentId: G.id, pattern: PAT,
      patternColour: PAT === 'Solid' ? null : $('patC').value,
      patternDensity: DENSITY, colours: cols,
      sizes: sizes, totalQty: totalQty(),
      playerName: $('pName') ? $('pName').value : '',
      playerNumber: $('pNum') ? $('pNum').value : '',
      textColour: $('textC') ? $('textC').value : '',
      nelyMark: { shown: true, colour: $('brandC').value },
      designUrl: shareUrl(),
      artwork: SLOTS.filter(function (s) { return s.file; }).map(function (s) {
        return {
          slot: s.label, view: s.side, file: s.file.name, vector: !s.img,
          x: +s.x.toFixed(3), y: +s.y.toFixed(3), size: s.size + '%'
        };
      })
    };
  }
  function specText(d) {
    var L = [];
    L.push('GARMENT   ' + d.garment);
    L.push('PATTERN   ' + d.pattern + (d.patternColour ? ' in ' + d.patternColour : '') +
           (d.pattern !== 'Solid' ? '  (repeat ' + d.patternDensity + ')' : ''));
    L.push('COLOURS');
    Object.keys(d.colours).forEach(function (k) {
      L.push('  ' + (k + '              ').slice(0, 14) + d.colours[k]);
    });
    L.push('SIZES');
    var keys = Object.keys(d.sizes);
    if (keys.length) {
      keys.forEach(function (k) { L.push('  ' + (k + '      ').slice(0, 6) + d.sizes[k]); });
      L.push('  TOTAL  ' + d.totalQty);
    } else L.push('  not specified');
    if (d.playerName || d.playerNumber)
      L.push('BACK      ' + d.playerName + (d.playerNumber ? '  no. ' + d.playerNumber : '') +
             '  in ' + d.textColour);
    L.push('NELY MARK ' + (d.nelyMark.shown ? d.nelyMark.colour : 'hidden'));
    if (d.artwork.length) {
      L.push('ARTWORK');
      d.artwork.forEach(function (a) {
        L.push('  ' + a.slot + ' (' + a.view + ') \u2014 ' + a.file +
               (a.vector ? ' [vector]' : ' [raster]') +
               ', x ' + a.x + ', y ' + a.y + ', width ' + a.size);
      });
      L.push('  Please reply to this email with the artwork files attached.');
    } else L.push('ARTWORK   none uploaded');
    L.push('');
    L.push('REOPEN THIS DESIGN');
    L.push('  ' + d.designUrl);
    return L.join('\n');
  }
  function readFiles(cb) {
    var withFiles = SLOTS.filter(function (s) { return s.file; }), out = [], left = withFiles.length;
    if (!left) return cb(out);
    withFiles.forEach(function (s) {
      var rd = new FileReader();
      rd.onload = function () {
        out.push({
          slot: s.label, view: s.side, filename: s.file.name,
          type: s.file.type || 'application/octet-stream',
          vector: !s.img, data: rd.result
        });
        if (!--left) cb(out);
      };
      rd.onerror = function () { if (!--left) cb(out); };
      rd.readAsDataURL(s.file);
    });
  }
  function sendJSON(d, msg) {
    if (msg) { msg.hidden = false; msg.className = 'form-msg'; msg.textContent = 'Sending\u2026'; }
    readFiles(function (files) {
      buildSpecSheet(function (sheet) {
        fetch(CFG.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ spec: d, preview: cv.toDataURL('image/png'), specSheet: sheet, artwork: files })
        })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function () {
            if (!msg) return;
            msg.className = 'form-msg'; msg.textContent = 'Sent. We will be in touch shortly.';
          })
          .catch(function () {
            if (!msg) return;
            msg.className = 'form-msg form-msg--err';
            msg.textContent = 'Could not send just now. Please email us directly.';
          });
      });
    });
  }

  var form = $('kb-form');
  if (form) {
    form.addEventListener('submit', function (ev) {
      var d = spec();
      if (CFG.endpoint) { ev.preventDefault(); sendJSON(d, $('msg')); return; }
      var hidden = $('kb-spec');
      if (hidden) hidden.value = specText(d);
    });
  } else if ($('send')) {
    $('send').onclick = function () {
      var msg = $('msg'), d = spec();
      if (!d.name || !d.email) {
        msg.hidden = false; msg.className = 'form-msg form-msg--err';
        msg.textContent = 'Please add your name and email so we can reply.';
        return;
      }
      sendJSON(d, msg);
    };
  }

  /* ---------- boot ---------- */
  buildGarments(); buildZones(); buildViews(); buildPatterns(); buildPresets();
  buildArt(); buildSizes(); syncPats(); loadKitFont();

  var qs = location.search.match(/[?&]d=([^&]+)/);
  var gq = location.search.match(/[?&]g=([a-z0-9-]+)/i);
  var st = qs ? decodeState(qs[1]) : null;
  if (st) applyState(st, render);
  else if (gq) {
    var want = GARMENTS.filter(function (x) { return x.id === gq[1]; })[0];
    if (want) {
      ensurePart(want, function () {
        G = want; V = G.views[0];
        buildGarments(); buildZones(); buildViews(); buildArt(); render();
      });
    } else ensurePart(G, render);
  } else ensurePart(G, render);
})();
